<template>
    <div class="page-notice-detail">

        <div class="business-detail">
            <el-row :gutter="18">
                <el-col :span="18">
                    <card class="paper" v-loading="loadingController">

                        <div class="print-btn noprint" @click="printPage">[打印]</div> 

                        <div class="context rich-text" v-html="detail.ggcontent"></div>
                    </card>
                </el-col>

                <el-col :span="6">
                    <card class="time-card right-card" v-loading="loadingController">
                        <div slot="title" class="title" :style="{color: myColor,}">
                            时间汇总
                        </div>

                        <el-timeline class="time-line">
                            <el-timeline-item :color="myColor">
                                <div class="time-line-item">
                                    <div class="title" :style="{color: myColor ,}">公告时间</div>
                                    <p>开始：{{detail.ggfbtime}}</p>
                                    <p>截止：{{detail.ggendtime}}</p>
                                </div>
                            </el-timeline-item>

                        </el-timeline>
                    </card>

                    <card class="guide-card right-card">
                        <div slot="title" class="title" :style="{color: myColor,}">
                            投标指南
                        </div>

                        <div class="guide-list">
                            <div class="item">
                                <img src="/images/notice/file1.png" alt="">
                                <div class="text">获取招标文件</div>
                            </div>

                            <div class="item">
                                <img src="/images/notice/file2.png" alt="">
                                <div class="text">递交/上传投标文件</div>
                            </div>
                        </div>
                    </card>

                </el-col>
            </el-row>

        </div>

    </div>
</template>

<script>
import { buildTdk } from '@config/tdk';
import appNode from '@js/app-node';

import Card from '@components/sys/card';



export default {
    components: {
        Card,
    },
    head () {
        var tdk = buildTdk('notice');
        var {
            ggcontent,
            // Data_content,
            // title_page,
            // zbfsname,
            // hyname,
            // cityname,
        } = this.detail;

        ggcontent = ggcontent || '';

        return {
            // title: `${Data_title}_${tdk.title}·${tdk.webName}`,
            title: `公告详情_${tdk.title}·${tdk.webName}`,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: ggcontent
                    .replace(/\<((?:.|\n)+?)\>/gi, '')
                    .replace(/\s/g, '')
                    .slice(0, 100),
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: `${ggcontent}`,
                },
            ],
        };
    },

    async asyncData (context) {
        // return;
        let detail = {};

        var infoid = context.query.ggcode,
            categoryid = context.query.categoryid || null,
            url = `${context.store.state.api.webUrl}/index/expand/ggdetail.json`,
            search = {
                infoid,
                categoryid,
            };

        try {

            await appNode.ssrReq
                .call(
                    context,
                    url,
                    search
                )
                .then((data, res) => {
                    detail = data;
                });

        } catch (e) {
            console.error(e);
        }

        return {
            detail,
        };
    },

    data () {
        return {
            // detail: {},
            loadingController: false,
            myColor: this.webInfo.themeColor,
        };
    },
    methods: {
        // 处理 "请求打印" 的消息
        printPage: function(event){
            window.print();
        },

    },
    mounted () {
        // this.getDetail();
    },
};
</script>

<style lang="scss" scoped>
.page-notice-detail {
    // background-color: #f8f9fb;
    // border-top: 1px solid #f8f9fb;
}

$tableBorder: 1px #dfdfdf solid;

.business-detail {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;

    .paper {
        min-height: 600px;
        background-color: #f8f9fb;
        box-shadow: 0px 9px 9px 0px #e8eaef;
        border: solid 2px #ffffff;
        margin-bottom: 10px;

        .title {
            font-size: 18px;
            color: #262626;
            text-align: center;
            padding-bottom: 24px;
            border-bottom: solid 1px #dfdfdf;
            margin-bottom: 1em;
        }

        .print-btn{
            font-size: 14px;
            margin: 0px auto;
            cursor: pointer;
            text-align: center;
            color: #3998FC;
        }

        .info-table {
            width: 100%;
            border-top: $tableBorder;
            border-left: $tableBorder;
            margin-bottom: 1em;

            td {
                border-right: $tableBorder;
                border-bottom: $tableBorder;
                padding: 1em;
            }
        }
    }

    .context {
        line-height: 2em;
        color: #262626;
    }

    .right-card {
        background-color: #f8f9fb;
        box-shadow: 0px 9px 9px 0px #e8eaef;
        border: solid 2px #ffffff;

        .title {
            color: #262626;
            font-size: 18px;
            font-weight: bold;
        }

        & + .right-card {
            margin-top: 12px;
        }
    }

    .time-card {
        .time-line {
            padding-left: 2px;
            padding-top: 8px;

            ::v-deep {
                .el-timeline-item__wrapper {
                    padding-left: 24px;
                    top: -6px;
                }
            }

            .time-line-item {
                background-color: #ebebeb;
                padding: 12px;
                color: #262626;
                position: relative;

                &:before {
                    content: '';
                    display: block;
                    width: 0.8em;
                    height: 0.8em;
                    position: absolute;
                    left: 0;
                    top: 1em;
                    transform: translate(-50%, -50%) rotate(45deg);
                    background-color: #ebebeb;
                }

                .title {
                    font-weight: bold;
                    margin-bottom: 10px;
                }

                p {
                    & + p {
                        margin-top: 10px;
                    }
                }
            }
        }
    }

    .guide-card {
        .guide-list {
            overflow: hidden;
            background-image: url('/images/notice/arrow.png');
            background-position: center top;
            background-repeat: no-repeat;

            .item {
                text-align: center;

                .text {
                    line-height: 1em;
                    margin-top: 12px;
                }

                &:first-child {
                    float: left;
                }

                &:last-child {
                    float: right;
                }
            }
        }
    }
}
</style>

// 打印参数
<style>
@media print {
  
  .noprint{ display : none }
     #copy{ display: block !important;}

    @page {
        size: A4;
        margin-top: 0;
        margin: 1cm 1cm;
    }

    body * {
        visibility: hidden;
    }

    body {
        padding: 0mm;
    }

    .layout-default,
    .layout-default * {
        visibility: visible;
    }

    .layout-default {
        zoom: 0.88;
        transform-origin: left center;
        margin-left: -130px;
    }

    .footer a , .footer .row , .footer .title , .footer .item {
        color: #666 !important;
     }


}

</style>